import { createContext } from 'react';

// When any PageHeader is mounted it flips `active` to true via the
// setter in context. MainPage reads `active` to suppress its own
// global mobile back button so the two don't overlap.
const PageHeaderContext = createContext({
  active: false,
  setActive: () => {},
});

export default PageHeaderContext;
